import type { FileModel, FileModelFR } from './FileModel';
import { translateFileModel } from './FileModel';
import type { ImageModel, ImageModelFR } from './ImageModel';
import { translateImageModel } from './ImageModel';

export type TeamMemberModelFR = {
	nom: string;
	prenom: string;
	fonction: string;
	urlLinkedIn: string;
	cv: FileModelFR;
	photo: ImageModelFR;
};

export type TeamMemberModel = {
	lastName: string;
	firstName: string;
	job: string;
	linkedIn: string;
	cv: FileModel;
	avatar: ImageModel;
};

export const translateTeamMember = (tm: TeamMemberModelFR): TeamMemberModel => {
	return {
		lastName: tm.nom,
		firstName: tm.prenom,
		job: tm.fonction,
		linkedIn: tm.urlLinkedIn,
		cv: tm.cv && translateFileModel(tm.cv),
		avatar: tm.photo && translateImageModel(tm.photo)
	};
};

export const translateTeamMemberArray = (tmA: TeamMemberModelFR[]): TeamMemberModel[] => {
	return tmA.map((e) => translateTeamMember(e));
};
